export default "__VITE_ASSET__QX2Y5FY___"